import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface IFormInputProps {
  type: string;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export default function FormInput(props: WrappedFieldProps & IFormInputProps) {
  const {
    input,
    type,
    placeholder = '',
    disabled = false,
    autoFocus = false,
    meta: { touched, error },
  } = props;

  return (
    <>
      <input
        {...input}
        id={input.name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        className={"form-control" + (error && touched ? " invalid-form-input" : "")}
      />
      {touched && error && <small className="invalid">{error}</small>}
    </>
  );
}
